import apiCall from '../utils/api-call/apiCall';
import { createHeaders } from "./constants";

const conpanyData = async (token) => {
  try {
    return await apiCall("impersonate/companies", "GET", null, createHeaders(token));
  } catch (error) {
    throw error;
  }
};

const conpanyUsersData = async (token, page, pageSize, selectedCompanyId, search) => {
  try {
    const params = { page, pageSize, companyId: selectedCompanyId, search };
    return await apiCall("admin/impersonate/users", "GET", params, createHeaders(token));
  } catch (error) {
    throw error;
  }
};

const startImpersonation = async (token, userId) => {
  try {
    const payload = {
      userId: String(userId),
    };
    return await apiCall("admin/impersonate/start", "POST", payload, createHeaders(token));
  } catch (error) {
    throw error;
  }
};

export { conpanyData, conpanyUsersData, startImpersonation };
